import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

/**
 * @method requestOtp
 * @method confirmOtp
 */
export default {
    config: function() {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} token
     */
    apiGetSurpriseBox: function(token, fortuneName) {
        var params = {};

        var url = this.config().bzbsUrl + "/fortune/"+fortuneName;
        return BzbsApi.connectBzbsPost(url, token, params);
    },
}
